/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export type DMapTileUrlBuilder = (tz: number, tx: number, ty: number) => string;
